import Comments from './comments'

$('.js__comments').each(function() {
  $(this).reactify(Comments, $(this).data())
  $(this).children().unwrap()
})
